import { useQuery } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { getDeals } from '@dealstack/frontend/shared/dataExchange/services/deal.service';

export interface DealOption {
	value: string;
	label: string;
	isRestricted: boolean;
}

export const useDealOptionsQuery = () => {
	return useQuery({
		queryKey: [API_PATHS.DEAL_GET],
		queryFn: ({ signal }) => getDeals(signal),
		select: (deals): DealOption[] =>
			deals
				.map((deal) => ({
					value: deal.id,
					label: deal.name,
					isRestricted: deal.isRestricted,
				}))
				.sort((left, right) => left.label.localeCompare(right.label)),
	});
};
